//@flow
import type { RoamingPackage } from 'digicel-kaizen-library';

export type BundleActionType = {|
  type: 'SET_ROAMING_BUNDLES',
  payload: { [string]: RoamingPackage },
|};

export const setRoamingBundles = (roamingBundles: { [string]: RoamingPackage }): BundleActionType => ({
  type: 'SET_ROAMING_BUNDLES',
  payload: roamingBundles,
});
